var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.54 8.81a2.96 2.96 0 1 1 0-5.92 2.96 2.96 0 0 1 0 5.92zM6.46 8.81a2.96 2.96 0 1 1 0-5.92 2.96 2.96 0 0 1 0 5.92zM17.54 21.111a2.96 2.96 0 1 1 0-5.92 2.96 2.96 0 0 1 0 5.92zM6.46 21.111a2.96 2.96 0 1 1 0-5.92 2.96 2.96 0 0 1 0 5.92z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMenu);
export default __webpack_public_path__ + "static/media/vuesax-bold-menu.a7e9aef9290b60a481ead40c394b3d89.svg";
export { ForwardRef as ReactComponent };